<template>
  <el-dialog title="授权信息确认" :visible.sync="dialogTableVisible">
    <el-descriptions>
      <el-descriptions-item
        :label="item.label"
        v-for="item in descriptionsItems.showData"
        :key="item.value"
        >{{ item.value }}
      </el-descriptions-item>
    </el-descriptions>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="
          dialogTableVisible = false;
          reject();
        "
        >取 消</el-button
      >
      <el-button v-if="type !== 'detail'" type="primary" @click="sendData()"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "ConfirmationDialog",
  props: {
    descriptionsItems: {
      type: Object,
      default: {
        postData: {},
        showData: []
      },
      resultData: ""
    }
  },
  data() {
    return {
      dialogTableVisible: false
    };
  },
  methods: {
    confirmationShow() {
      this.dialogTableVisible = true;
    },
    // 提交数据
    sendData() {
      const that = this;
      this.$ajax({
        method: "POST",
        url: "/api/license/gen_lic", // todo url
        data: that.descriptionsItems.postData
      }).then(
        function(response) {
          if (response.data["code"] !== 200) {
            const errorString = "接口返回失败:" + response.data["message"];
            that.$message.error(errorString);
          } else {
            that.resultData = response.data["data"]["result"];
            that.$emit("sendResult", that.resultData);
            that.dialogTableVisible = false;
            that.$message.success("生成授权码成功，可点击复制授权码");
          }
        },
        function() {
          that.$message.error("接口请求失败,请联系管理员");
        }
      );
    }
  }
};
</script>
